<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title" v-text="title"></div>
        <DropdownScrollable placeholder="Chọn công ty" :limit="company_obj.limit" :loading="company_obj.loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="company_obj.items" :total="company_obj.total" @keyup="emitEvent" @offset="changeOffset"/>
        <BaseDatatable
          :key="componentKey"
          :tableData="listData"
          :model="dataModel"
          :options="options"
          :filterDefault="filters"
          :getFilterOptions="getFilterOptions"
          :actions="getRowActions()"
          v-on:action-click="onActionClicked"
          @onDataChange="DataOnChange"
          :company="company"
          :company_id="company_id"
        ></BaseDatatable>
        <Dialog
          style=""
          header="Xóa"
          :visible.sync="showDeleteDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          Bạn có chắc muốn xoá khoá học này không?
          <template
            #footer
          >
            <Button label="Delete" @click="deleteData()" icon="pi pi-check" class="p-button-danger" />
            <Button
              label="Cancel"
              @click="showDeleteDialog = false"
              icon="pi pi-times"
              class="p-button-warning callback-btn"
            />
          </template>
        </Dialog>
        <Dialog style="" header="Tạo khóa học" :visible.sync="showCourseTypeDialog" :contentStyle="{overflow: 'visible'}" :modal="true">
          <div style="width: 380px;">
            <span>Bạn muốn tạo loại khóa học nào?</span>
          </div>
          <div style="padding-top: 4px;" class="Hehehe">
            <div v-if="course.status=='Online'" style="display:flex">
              <Button label="Offline" @click="clickOffline()" class="" style="margin:2px;color:#666666;background-color: #F3F4F7;border: 1px solid #F3F4F7;width: 100%;"/>
              <Button label="Online" @click="clickOnline()" class="" style="margin:2px;color:#0086C4;background-color:#E5F3FA;font-weight: 700;width: 100%;"/>
            </div>
            <div v-else style="display:flex">
              <Button label="Offline" @click="clickOffline()" class="" style="margin:2px;color:#0086C4;background-color:#E5F3FA;font-weight: 700;width: 100%;"/>
              <Button label="Online" @click="clickOnline()" class="" style="margin:2px;color:#666666;background-color: #F3F4F7;border: 1px solid #F3F4F7;width: 100%;"/>
            </div>
          </div>
          <template #footer >
            <Button label="Hủy" @click="showCourseTypeDialog = false" icon="pi pi-times" class="p-button-disa"/>
            <Button label="Xác nhận" @click="goPageSel()" icon="pi pi-check" class="" />
          </template>
        </Dialog>
        <Dialog
          header="Thông báo"
          :visible.sync="showWarningDialog"
          :modal="true"
          :closable="true"
          @hide="showWarningDialog = false"
        >
          <div class="p-d-flex p-jc-center">
            <p>HỆ THỐNG ĐANG PHÁT TRIỂN !!!!!!!!!!!!!</p>
            <Button label="OK" class="p-button-warning" @click="showWarningDialog = false" />
          </div>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import ApiRepository from "@/core/ApiRepository";
import BaseDatatable from './list'
import DropdownScrollable from '@/components/DropdownScrollable.vue';
export default {
  components: {
    BaseDatatable,
    DropdownScrollable
  },
  data() {
    return {
      filters : {},
      filterOptions: {},
      options: [],
      listData: [],
      modelName: '',
      dataModel: null,
      title: null,
      componentKey: 0,
      page_transaction:null,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      dataDelete :{},
      company: {},
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      company_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      company_id: null,
      showCourseTypeDialog: false,
      showWarningDialog: false,
      pendingAction: null,
      pendingData: null,
      course: {
            status : 'Offline',
        },
    }
  },
  async created() {
    await this.initParams();
    if ((this.$store.getters?.type == this.$constants.TYPE_USER.SUPPER_ADMIN)) {
      await this.getListCompany()
    }
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel(this.modelName);
    // console.log('this.dataModel:',this.dataModel);
    // this.title = this.dataModel.name
    this.$store.commit('setLoading', true);
    if(this.$route.params.reload) {
      window.location.reload();
    }
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.company_id)){
        if ((this.$store.getters?.type == this.$constants.TYPE_USER.SUPPER_ADMIN)) {
          this.company = {id: this.$route.query.company_id};
          setTimeout(() => {
            const query = Object.assign({}, this.$route.query);
            delete query.company_id;
            this.$router.replace({ query });
          }, 100);
        }
      }
    }
    
    // var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_BANNER);
    // if (arr_role.indexOf(this.$constants.ROLE.VIEW) < 0){
    //   this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
    // }
    // this.role.add = (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) ? false:true;
    // this.role.edit = (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) ? false:true;
    // this.role.delete = (arr_role.indexOf(this.$constants.ROLE.DELETE) < 0) ? false:true;
  },
  watch: {
    '$route': 'initParams',
    async 'company'() {
      if ((this.$store.getters?.type == this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.company_id = this.company.id;
        this.componentKey++;
      }
    },
  },
  methods: {
    emitEvent(keyword) {
      this.$delete(this.company_obj.filters, 'name');
      if (keyword) {
        this.company_obj.filters.name = keyword;
      }
      this.getListCompany();
    },
    changeOffset(value) {
      this.company_obj.offset = value;
      // this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.company_obj.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.company_obj.filters, limit: this.company_obj.limit, offset: this.company_obj.offset}, {headers}).then((res) => {
          if (this.company_obj.offset > 0 ) {
            this.company_obj.items.push(...res.data.data.company);
          } else{
            this.company_obj.items = res.data.data.company;
          }
          this.company_obj.total = res.data.data.total;
          this.company_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.company_obj.loading = false;
        })
      }
    },
    async initParams() {
      this.$store.commit('setLoading', true);
      if (this.$store.getters.type !== this.$constants.TYPE_USER.SUPPER_ADMIN) {
        this.company = {id : this.$store.getters?.company_id}
        this.company_id = this.$store.getters?.company_id;
        // this.componentKey++
      }
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      await this.$set(this, 'title', this.dataModel.label);
      // this.callbackOptions();
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    DataOnChange(data,f){
      if(f.type == 'Checkbox'){
      //   let dataUpdate = {}
      //   if(f.key == 'active'){
      //     dataUpdate['active'] = data[f.key]
      //   }
      //   let variables = {
      //     'data_update': dataUpdate,
      //     'where_key': {
      //       'id': {'_eq': data.id}
      //     }
      //   };
      //   this.$apollo.mutate({
      //     mutation: DataServices.updateData(this.modelName),
      //     variables: variables
      //   }).then(() => {})
      }
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      // console.log("field",field)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      // console.log("result",result)
      return result;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      if (that.$store.getters.controllers?.list_course && that.$store.getters.controllers?.list_course.includes('add')) {
        actions.header = {name: 'add', icon: 'plus', path: `list-course/add`};
      }
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var buttons = {}
        //buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-${that.modelName}/view/`};
        if (that.$store.getters.controllers?.list_course&& that.$store.getters.controllers?.list_course.includes('view')) {
          buttons.view = {name: 'view', icon: 'eye', key: 'id', path: `list-course/view/`};
        }
        if (that.$store.getters.controllers?.list_course && that.$store.getters.controllers?.list_course.includes('edit')) {
          buttons.edit = {name: 'edit', icon: 'pencil', key: 'id', path: `list-course/edit/`};
        }
        if (that.$store.getters.controllers?.list_course&& that.$store.getters.controllers?.list_course.includes('delete')) {
          buttons.delete = {name: 'delete', icon: 'trash', key: 'id'};
        }
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async callbackOptions() {
      this.dataModel.getDisplayFields();
    //   var attributes = [];
    //   for (let index = 0; index < fields.length; index++) {
    //     const element = fields[index];
    //     if (element.models !== undefined && element.models !== null) {
    //       // console.log("SDFGHJK",element)
    //       var optionsData = [];
    //       attributes.push(element.models.key.key);
    //       attributes.push(element.models.display_key);
    //       var where_ = {}
    //       if( element['name']== "name_country"){
    //         // console.log("element",element)
    //         let {data} = await this.$apollo.query({
    //           query: DataServices.getList("country", {"fields" : "id country_lang{lang name}"}),
    //           variables: {
    //             where_key : {
    //               deleted : {_eq: false}
    //             },
    //             orderBy:[{ordinal: 'desc'},{created_at : 'desc'}]
    //           }
    //         })
    //         if (data) {
    //           var ress = data[Object.keys(data)];
    //           if (ress) {
    //             for (let index = 0; index < ress.length; index++) {
    //               const ele = ress[index];
    //               var name_country = ''
    //               if(ele.country_lang){
    //                 for (let j = 0; j < ele.country_lang.length; j++) {
    //                   if(ele.country_lang[j].lang == 'en'){
    //                     name_country = ele.country_lang[j].name;
    //                     break;
    //                   }
    //                 }
    //               }
    //               if(name_country !== ''){
    //                 optionsData.push({value: ele.id, label: name_country})
    //               }
    //             }
    //           }
    //         }
    //       }else{
    //         let {data} = await this.$apollo.query({
    //           query: DataServices.getList(element.models.tableName, {"fields" : attributes.join(',')}),
    //           variables: {where_key : where_}
    //         })
    //         if (data) {
    //           var result = data[Object.keys(data)];
    //           if (result) {
    //             for (let index = 0; index < result.length; index++) {
    //               const ele = result[index];
    //               optionsData.push({value: ele[attributes[0]], label: ele[attributes[1]]})
    //             }
    //           }
    //         }
    //       }
    //       // console.log("optionsData",optionsData)
    //       this.options[element.key] = optionsData;
    //     }
    //     this.componentKey++;
    //   }

    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      this.pendingAction = action;
      this.pendingData = data;

      switch (action.name) {
        case 'add':
          this.showCourseTypeDialog = true;
          break;
        case 'edit':
          if (data.data.type === 'online') {
             //gọi api lấy link tạo khóa học
            var token = this.$store.getters.token ? this.$store.getters.token : null
            const headers = {
              "Authorization": "Bearer "+token,
            };
            var map_id = data.data.map_id;
            var that = this;
            await ApiRepository.post("/_api/users/get_token_kh", {}, {headers}).then(function (res) {
              // console.log("res====",res.data)
              var value = res.data.data;
              // console.log("map_id==",map_id)
              var uri = value.url_kh +`/`+that.$constants.URL_KHOA_HOC.EDIT_KHOA_HOC+`/`+map_id+`?token=`+value.token_callback;
              // console.log("uri======",uri)
              window.open(uri, '_blank');
            });
            // this.showWarningDialog = true;
            
          } else if (data.data.type === 'offline') {
            this.dialogMode = action.name
            if (action.path !== undefined && action.path) {
              localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
              this.$router.push({ path: action.path + data.data[action.key],query: { page_transaction: pageTransaction.toString(), company_id: this.company?.id }  })
            } else  {
              this.page_transaction = pageTransaction.toString();
              localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
              this.editId = data.data[action.key]
              this.displayDialog = true
              this.editDialogKey++
            }
          break
          }
          break;
        case 'delete':
          this.deleteId = data.data[action.key];
          this.deleteName = data.data.name_en;
          this.dataDelete = data.data;
          this.showDeleteDialog = true;
          break;
        case 'view':
          if (data.data.type === 'online') {
            var _map_id = data.data.map_id;
            var uri = this.$ConfigEvn.base_url_khoa_hoc+`/`+this.$constants.URL_KHOA_HOC.VIEW_KHOA_HOC+'/'+_map_id
            window.open(uri, '_blank');
            return;
            // lấy có token
            // var token = this.$store.getters.token ? this.$store.getters.token : null
            // const headers = {
            //   "Authorization": "Bearer "+token,
            // };
            // var _map_id = data.data.map_id;
            // var that = this;
            // await ApiRepository.post("/_api/users/get_token_kh", {}, {headers}).then(function (res) {
            //   // console.log("res====",res.data)
            //   var value = res.data.data;
            //   // console.log("map_id==",_map_id)
            //   var uri = value.url_kh +`/`+that.$constants.URL_KHOA_HOC.VIEW_KHOA_HOC+`/`+_map_id+`?token=`+value.token_callback;
            //   // console.log("uri======",uri)
            //   window.open(uri, '_blank');
            // });
          }
          this.dialogMode = action.name;
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key], query: { company_id: this.company?.id } });
          } else {
            this.editId = data.data[action.key];
            this.displayDialog = true;
            this.editDialogKey++;
          }
          break;
        case 'custom':
          await action.handler(data.data, this);
          this.componentKey++;
          break;
      }
    },
    clickOnline(){
      this.course.status = "Online"
    },
    clickOffline(){
      this.course.status = "Offline"
    },
    async goPageSel(){
        if(!this.course.status){
            alert('Vui lòng chọn khóa học.');
            return;
        }
        if(this.course.status == "Online"){
          //gọi api lấy link tạo khóa học
          var token = this.$store.getters.token ? this.$store.getters.token : null
          const headers = {
            "Authorization": "Bearer "+token,
          };
          var {data} = await ApiRepository.post("/_api/users/get_token_kh", {}, {headers});
          var value = data.data;
          var uri = value.url_kh +'/'+this.$constants.URL_KHOA_HOC.ADD_KHOA_HOC+"?token="+value.token_callback;
          // console.log("uri======",uri)
          window.open(uri, '_blank');
          // window.location.href = uri
          // this.showWarningDialog = true;
        } else if (this.course.status == "Offline"){
          this.$router.push({ path: 'list-course/add'});
        }
    },
    async sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async deleteData() {
      this.showDeleteDialog = false;
      var token = this.$store.getters.token ? this.$store.getters.token : null;
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/course/delete", {id: that.deleteId, company_id: that.company.id}, {headers}).then(function () {
          that.componentKey += 1;
        }).catch((err) => {
          const error = err.response.data;
          if (error.message == "COURSE_IS_EXIST_IN_SRA"){
            this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: ' khoá học đã tồn tại trong SRA', life: 3000 })
          }
          else if (error.message == "MISMATCH_PARAMS_ERR"){
            this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Thiếu trường bắt buộc', life: 3000 })
          }
          else this.$toast.add({severity: 'error', summary: 'Lỗi', detail: 'Xóa dữ liệu thất bại', life: 3000});
        })
      }
    }
  },
}
</script>
<style lang="css">
.p-calendar .p-datepicker { width: 280px; padding: 0px; padding-top: 5px;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
.p-button-warning-o .p-button-label-o{
  color: #e95d57;
}
.p-button-warning .pi-times{
  color: #e95d57;
}
.p-button-disa {
  color : #666666;
  background-color : #F2F3F7;
  border: 1px solid #F2F3F7;
}
.p-button-disa:hover {
  background-color: #F2F3F7 !important;
  border: 1px solid #F2F3F7 !important;
  color : #666666 !important;
}
</style>